// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "container-LUNFV";
var _4 = "consent-3EG5Z";
var _5 = "disableTermsOfTariff-21Evp";
export { _1 as "__esModule", _2 as "mobile", _3 as "container", _4 as "consent", _5 as "disableTermsOfTariff" }
export default { "__esModule": _1, "mobile": _2, "container": _3, "consent": _4, "disableTermsOfTariff": _5 }
